import { rule } from "postcss";

class Validator {

    en = {
        nif: 'This field must be a valid NIF.',
        required: 'This field is required.',
        minLength: 'This field must be at least {0} characters long.',
        maxLength: 'This field must be no more than {0} characters long.',
        min: 'This field must be at least {0}.',
        max: 'This field must be no more than {0}.',
        email: 'This field must be a valid email address.',
        between: 'This field must be between {0} and {1}.',
        in: 'This field must be one of the following values: {0}.',
        number: 'This field must be a number.',
        integer: 'This field must be an integer.',
        date: 'This field must be a valid date.',
        match: 'This field must match the format: {0}',
        eq: 'This field must be equal to {0}.',
        neq: 'This field must not be equal to {0}.',
        gt: 'This field must be greater than {0}.',
        lt: 'This field must be less than {0}.',
        leq: 'This field must be exactly {0} characters long.',
        lgt: 'This field must be longer than {0} characters.',
        llt: 'This field must be shorter than {0} characters.',
        "not-empty": 'This field must not be empty.',
        start: 'This field must start with {0}.',
        end: 'This field must end with {0}.',
        uppercase: 'This field must be in uppercase.',
        lowercase: 'This field must be in lowercase.',
        hasNumber: 'This field must contain at least {0} digits.',
        hasLowercaseLetters: 'This field must contain at least {0} lowercase letters.',
        hasUppercaseLetters: 'This field must contain at least {0} uppercase letters.',
        hasSpecialCharacters: 'This field must contain at least {0} special characters.'
    }

    pt = {
        nif: 'Este campo deve ser um NIF válido.',
        required: 'Este campo é obrigatório.',
        minLength: 'Este campo deve ter pelo menos {0} caracteres.',
        maxLength: 'Este campo deve ter no máximo {0} caracteres.',
        min: 'Este campo deve ser pelo menos {0}.',
        max: 'Este campo deve ser no máximo {0}.',
        email: 'Este campo deve ser um endereço de email válido.',
        between: 'Este campo deve estar entre {0} e {1}.',
        in: 'Este campo deve ser um dos seguintes valores: {0}.',
        number: 'Este campo deve ser um número.',
        integer: 'Este campo deve ser um número inteiro.',
        date: 'Este campo deve ser uma data válida.',
        match: 'Este campo deve corresponder ao formato: {0}',
        eq: 'Este campo deve ser igual a {0}.',
        neq: 'Este campo não deve ser igual a {0}.',
        gt: 'Este campo deve ser maior que {0}.',
        lt: 'Este campo deve ser menor que {0}.',
        leq: 'Este campo deve ter exatamente {0} caracteres.',
        lgt: 'Este campo deve ter mais de {0} caracteres.',
        llt: 'Este campo deve ter menos de {0} caracteres.',
        "not-empty": 'Este campo não pode estar vazio.',
        start: 'Este campo deve começar com {0}.',
        end: 'Este campo deve terminar com {0}.',
        uppercase: 'Este campo deve estar em maiúsculas.',
        lowercase: 'Este campo deve estar em minúsculas.',
        hasNumber: 'Este campo deve conter pelo menos {0} dígitos.',
        hasLowercaseLetters: 'Este campo deve conter pelo menos {0} letras minúsculas.',
        hasUppercaseLetters: 'Este campo deve conter pelo menos {0} letras maiúsculas.',
        hasSpecialCharacters: 'Este campo deve conter pelo menos {0} caracteres especiais.'
    };

    es = {
        nif: 'Este campo debe ser un NIF válido.',
        required: 'Este campo es obligatorio.',
        minLength: 'Este campo debe tener al menos {0} caracteres.',
        maxLength: 'Este campo debe tener como máximo {0} caracteres.',
        min: 'Este campo debe ser al menos {0}.',
        max: 'Este campo debe ser como máximo {0}.',
        email: 'Este campo debe ser una dirección de correo electrónico válida.',
        between: 'Este campo debe estar entre {0} y {1}.',
        in: 'Este campo debe ser uno de los siguientes valores: {0}.',
        number: 'Este campo debe ser un número.',
        integer: 'Este campo debe ser un número entero.',
        date: 'Este campo debe ser una fecha válida.',
        match: 'Este campo debe coincidir con el formato: {0}',
        eq: 'Este campo debe ser igual a {0}.',
        neq: 'Este campo no debe ser igual a {0}.',
        gt: 'Este campo debe ser mayor que {0}.',
        lt: 'Este campo debe ser menor que {0}.',
        leq: 'Este campo debe tener exactamente {0} caracteres.',
        lgt: 'Este campo debe tener más de {0} caracteres.',
        llt: 'Este campo debe tener menos de {0} caracteres.',
        "not-empty": 'Este campo no puede estar vacío.',
        start: 'Este campo debe comenzar con {0}.',
        end: 'Este campo debe terminar con {0}.',
        uppercase: 'Este campo debe estar en mayúsculas.',
        lowercase: 'Este campo debe estar en minúsculas.',
        hasNumber: 'Este campo debe contener al menos {0} dígitos.',
        hasLowercaseLetters: 'Este campo debe contener al menos {0} letras minúsculas.',
        hasUppercaseLetters: 'Este campo debe contener al menos {0} letras mayúsculas.',
        hasSpecialCharacters: 'Este campo debe contener al menos {0} caracteres especiales.'
    };

    fr = {
        nif: 'Ce champ doit être un NIF valide.',
        required: 'Ce champ est obligatoire.',
        minLength: 'Ce champ doit contenir au moins {0} caractères.',
        maxLength: 'Ce champ ne doit pas dépasser {0} caractères.',
        min: 'Ce champ doit être au moins {0}.',
        max: 'Ce champ ne doit pas dépasser {0}.',
        email: 'Ce champ doit être une adresse e-mail valide.',
        between: 'Ce champ doit être compris entre {0} et {1}.',
        in: 'Ce champ doit être l\'une des valeurs suivantes : {0}.',
        number: 'Ce champ doit être un nombre.',
        integer: 'Ce champ doit être un nombre entier.',
        date: 'Ce champ doit être une date valide.',
        match: 'Ce champ doit correspondre au format : {0}',
        eq: 'Ce champ doit être égal à {0}.',
        neq: 'Ce champ ne doit pas être égal à {0}.',
        gt: 'Ce champ doit être supérieur à {0}.',
        lt: 'Ce champ doit être inférieur à {0}.',
        leq: 'Ce champ doit contenir exactement {0} caractères.',
        lgt: 'Ce champ doit contenir plus de {0} caractères.',
        llt: 'Ce champ doit contenir moins de {0} caractères.',
        "not-empty": 'Ce champ ne peut pas être vide.',
        start: 'Ce champ doit commencer par {0}.',
        end: 'Ce champ doit se terminer par {0}.',
        uppercase: 'Ce champ doit être en majuscules.',
        lowercase: 'Ce champ doit être en minuscules.',
        hasNumber: 'Ce champ doit contenir au moins {0} chiffres.',
        hasLowercaseLetters: 'Ce champ doit contenir au moins {0} lettres minuscules.',
        hasUppercaseLetters: 'Ce champ doit contenir au moins {0} lettres majuscules.',
        hasSpecialCharacters: 'Ce champ doit contenir au moins {0} caractères spéciaux.'
    };

    constructor(language = 'pt') {
        this.customValidations = {};
        this.errors = {}
        this.subscribers = [];
        this.language = language;
    }


    setLanguage(lang){
        this.language = lang
    }


    subscribe(subscriber) {
        this.subscribers.push(subscriber);
    }


    registerValidation(ruleName, validationFunction) {
        this.customValidations[ruleName] = validationFunction;
    }

    setRules(rules) {
        for (const rule of rules) {
            this.registerValidation(rule.name, rule.validation);
        }
    }

    parseRules(rules) {
        if (!rules) { return []; }
        return rules.split('|').map(rule => {
            const trimmedRule = rule.trim();
            const colonIndex = trimmedRule.indexOf(':');
            
            if (colonIndex === -1) {
                return {
                    name: trimmedRule,
                    params: []
                };
            }
            
            const name = trimmedRule.substring(0, colonIndex);
            const paramString = trimmedRule.substring(colonIndex + 1);
            
            if (!paramString) {
                return {
                    name: name,
                    params: []
                };
            }
            
            // Handle quoted parameters
            const params = [];
            let currentParam = '';
            let inQuotes = false;
            let quoteChar = '';
            
            for (let i = 0; i < paramString.length; i++) {
                const char = paramString[i];
                
                if (!inQuotes && (char === '"' || char === "'")) {
                    inQuotes = true;
                    quoteChar = char;
                    continue
                } else if (inQuotes && char === quoteChar) {
                    inQuotes = false;
                    quoteChar = '';
                    continue
                } else if (!inQuotes && char === ',') {
                    params.push(currentParam.trim());
                    currentParam = '';
                    continue;
                }
                
                currentParam += char;
            }
            
            // Add the last parameter
            if (currentParam || currentParam === '') {
                params.push(currentParam.trim());
            }
            
            return {
                name: name,
                params: params
            };
        });
    }

    isValid() {
        return Object.keys(this.errors).length == 0;
    }

    getErrors() {
        return this.errors;
    }

    validateAll(lang = '') {
        if(lang!=''){
            this.language = lang
        }
        for (const sub of this.subscribers) {
            sub.validate();
        }
    }

    reset() {
        this.errors = {};
        for (const sub of this.subscribers) {
            sub.reset();
        }
    }
    validate(input) {
        const result = this.doValidate(input);
        if (!result.valid ) {
            this.errors[input.id] = {
                error: result.description ,
                value: input.value,
                rule: result.rule,
                field:input.field,
            }
        }
        else if(input.internalError){
            this.errors[input.id] = {
                error: input.internalError ,
                value: input.value,
                rule: result.rule,
                field:input.field,
            }            
        } 
        else {
            delete this.errors[input.id];
        }
        return result;
    }


    doValidate(input) {
        const rules = this.parseRules(input.rules);

        for (const rule of rules) {



            if (rule.name === 'nif' && !this.validateNIF(input.value)) {
                return {
                    valid: false,
                    rule: 'nif',
                    value: input.value,
                    description: this[this.language].nif
                };
            }

            if (rule.name === 'required' && (input.value === undefined || input.value === null || input.value === '')) {
                return {
                    valid: false,
                    rule: 'required',
                    value: input.value,
                    description: this[this.language].required
                };
            }
            if ((rule.name === 'min-length' || rule.name === 'minl') && input.value.length < parseInt(rule.params[0], 10) && input.value) {
                return {
                    valid: false,
                    rule: 'minLength',
                    value: input.value,
                    description: this[this.language].minLength.replace('{0}', rule.params[0])
                };
            }
            if ((rule.name === 'max-length' || rule.name === 'maxl') && input.value.length > parseInt(rule.params[0], 10) && input.value) {
                return {

                    valid: false,
                    rule: 'maxLength',
                    value: input.value,
                    description: this[this.language].maxLength.replace('{0}', rule.params[0])
                };
            }
            if (rule.name === 'min' && parseFloat(input.value) < parseFloat(rule.params[0])) {
                return {
                    valid: false,
                    rule: 'min',
                    value: input.value,
                    description: this[this.language].min.replace('{0}', rule.params[0])
                };
            }
            if (rule.name === 'max' && parseFloat(input.value) > parseFloat(rule.params[0])) {
                return {
                    valid: false,
                    rule: 'max',
                    value: input.value,
                    description: this[this.language].max.replace('{0}', rule.params[0])
                };
            }
            if (rule.name === 'email' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(input.value)) {
                return {
                    valid: false,
                    rule: 'email',
                    value: input.value,
                    description: this[this.language].email
                };
            }
            if (rule.name === 'between' && (parseFloat(input.value) < parseFloat(rule.params[0]) || parseFloat(input.value) > parseFloat(rule.params[1]))) {
                return {
                    valid: false,
                    rule: 'between',
                    value: input.value,
                    description: this[this.language].between.replace('{0}', rule.params[0]).replace('{1}', rule.params[1])
                };
            }
            if (rule.name === 'in') {
                // if (input.value && !rule.params[0].split('').every(param => input.value.includes(param))) {
                if (input.value && !input.value.split('').every(char => rule.params[0].includes(char))) {
                    return {
                        valid: false,
                        rule: 'in',
                        value: input.value,
                        description: this[this.language].in.replace('{0}', rule.params.join(', '))
                    };
                }
            }

            if ((rule.name === 'number' || rule.name ==='num') && isNaN(Number(input.value))) {
                return {
                    valid: false,
                    rule: 'number',
                    value: input.value,
                    description: this[this.language].number
                };
            }

            if (rule.name === 'integer' && (!Number.isInteger(Number(input.value)) || isNaN(parseFloat(input.value)))) {
                return {
                    valid: false,
                    rule: 'integer',
                    value: input.value,
                    description: this[this.language].integer
                };
            }
            if (rule.name === 'date' && isNaN(Date.parse(input.value))) {
                return {
                    valid: false,
                    rule: 'date',
                    value: input.value,
                    description: this[this.language].date
                };
            }

            if (rule.name === 'match') {
                const format = rule.params[0];
                const regex = this.createRegexFromFormat(format);
                if (!regex.test(input.value)) {
                    return {
                        rule: 'match',
                        value: input.value,
                        description: this[this.language].match.replace('{0}', format)
                    };
                }
            }

            if (rule.name === 'eq' && input.value !== rule.params[0]) {
                return {
                    valid: false,
                    rule: 'equals',
                    value: input.value,
                    description: this[this.language].eq.replace('{0}', rule.params[0])
                };
            }

            if (rule.name === 'neq' && input.value == rule.params[0]) {
                return {
                    valid: false,
                    rule: 'notEquals',
                    value: input.value,
                    description: this[this.language].neq.replace('{0}', rule.params[0])
                };
            }

            if (rule.name === 'gt' && parseFloat(input.value) <= parseFloat(rule.params[0])) {
                return {
                    valid: false,
                    rule: 'gt',
                    value: input.value,
                    description: this[this.language].gt.replace('{0}', rule.params[0])
                };
            }

            if (rule.name === 'lt' && parseFloat(input.value) >= parseFloat(rule.params[0])) {
                return {
                    valid: false,
                    rule: 'lt',
                    value: input.value,
                    description: this[this.language].lt.replace('{0}', rule.params[0])
                };
            }

            if (rule.name === 'len' && input.value.length !== parseInt(rule.params[0], 10)) {
                return {
                    valid: false,
                    rule: 'lengthEquals',
                    value: input.value,
                    description: this[this.language].leq.replace('{0}', rule.params[0])
                };
            }

            if (rule.name === 'lgt' && input.value.length <= parseInt(rule.params[0], 10)) {
                return {
                    valid: false,
                    rule: 'lengthGreaterThan',
                    value: input.value,
                    description: this[this.language].lgt.replace('{0}', rule.params[0])
                };
            }

            if (rule.name === 'llt' && input.value.length >= parseInt(rule.params[0], 10)) {
                return {
                    valid: false,
                    rule: 'lengthLessThan',
                    value: input.value,
                    description: this[this.language].llt.replace('{0}', rule.params[0])
                };
            }

            if (rule.name === 'not-empty' && (Array.isArray(input.value) || typeof input.value === 'object' || typeof input.value === 'string') && Object.keys(input.value).length === 0) {
                return {
                    valid: false,
                    rule: 'notEmpty',
                    value: input.value,
                    description: this[this.language]["not-empty"]
                };
            }

            if (rule.name === 'start' && !input.value.startsWith(rule.params[0])) {
                return {
                    valid: false,
                    rule: 'start',
                    value: input.value,
                    description: this[this.language].start.replace('{0}', rule.params[0])
                };
            }

            if (rule.name === 'end' && !input.value.endsWith(rule.params[0])) {
                return {
                    valid: false,
                    rule: 'end',
                    value: input.value,
                    description: this[this.language].end.replace('{0}', rule.params[0])
                };
            }

            if (rule.name === 'uppercase' && input.value !== input.value.toUpperCase()) {
                return {
                    valid: false,
                    rule: 'uppercase',
                    value: input.value,
                    description: this[this.language].uppercase
                };
            }

            if (rule.name === 'lowercase' && input.value !== input.value.toLowerCase()) {
                return {
                    valid: false,
                    rule: 'lowercase',
                    value: input.value,
                    description: this[this.language].lowercase
                };
            }
            if (rule.name === 'hasNumber') {
                const minDigits = parseInt(rule.params[0] || '1', 10);
                const digitCount = (input.value.match(/\d/g) || []).length;
                if (digitCount < minDigits) {
                    return {
                        valid: false,
                        rule: 'hasNumber',
                        value: input.value,
                        description: this[this.language].hasNumber.replace('{0}', minDigits)
                    };
                }
            }

            if (rule.name === 'hasLower') {
                const minLowercase = parseInt(rule.params[0] || '1', 10);
                const lowercaseCount = (input.value.match(/[a-z]/g) || []).length;
                if (lowercaseCount < minLowercase) {
                    return {
                        valid: false,
                        rule: 'hasLowercaseLetters',
                        value: input.value,
                        description: this[this.language].hasLowercaseLetters.replace('{0}', minLowercase)
                    };
                }
            }

            if (rule.name === 'hasUpper') {
                const minUppercase = parseInt(rule.params[0] || '1', 10);
                const uppercaseCount = (input.value.match(/[A-Z]/g) || []).length;
                if (uppercaseCount < minUppercase) {
                    return {
                        valid: false,
                        rule: 'hasUppercaseLetters',
                        value: input.value,
                        description: this[this.language].hasUppercaseLetters.replace('{0}', minUppercase)
                    };
                }
            }

            if (rule.name === 'hasSpecial') {
                const minSpecialChars = parseInt(rule.params[0] || '1', 10);
                const specialCharCount = (input.value.match(/[^a-zA-Z0-9]/g) || []).length;
                if (specialCharCount < minSpecialChars) {
                    return {
                        valid: false,
                        rule: 'hasSpecialCharacters',
                        value: input.value,
                        description: this[this.language].hasSpecialCharacters.replace('{0}', minSpecialChars)
                    };
                }
            }


            if (this.customValidations[rule.name]) {
                if (typeof this.customValidations[rule.name] === 'function') {
                    const result = this.customValidations[rule.name](input.value, rule.params);
                    if (!(result?.valid ?? true)) {
                        if (result?.description && typeof result.description === 'string') {
                            return result;
                        } else if (result?.description && typeof result.description === 'object') {
                            return {
                                valid: false,
                                rule: rule.name,
                                value: input.value,
                                description: result.description[this.language] ?? ''
                            };
                        }

                    }

                } else {
                    return this.doValidate({
                        id: -1,
                        value: input.value,
                        rules: this.customValidations[rule.name]
                    });
                }
            }
        }

        return {
            valid: true,
            rule: 'valid',
            value: input.value,
            description: ''
        };
    }

    validateNIF(value) {
        let error = 0;

        let comparador = 0;

        if (
            value.substr(0, 1) != '1' && // pessoa singular
            value.substr(0, 1) != '2' && // pessoa singular
            value.substr(0, 1) != '3' && // pessoa singular
            value.substr(0, 2) != '45' && // pessoa singular não residente
            value.substr(0, 1) != '5' && // pessoa colectiva
            value.substr(0, 1) != '6' && // administração pública
            value.substr(0, 2) != '70' && // herança indivisa
            value.substr(0, 2) != '74' && // herança indivisa
            value.substr(0, 2) != '75' && // herança indivisa
            value.substr(0, 2) != '71' && // pessoa colectiva não residente
            value.substr(0, 2) != '72' && // fundos de investimento
            value.substr(0, 2) != '77' && // atribuição oficiosa
            value.substr(0, 2) != '79' && // regime excepcional
            value.substr(0, 1) != '8' && // empresário em nome individual (extinto)
            value.substr(0, 2) != '90' && // condominios e sociedades irregulares
            value.substr(0, 2) != '91' && // condominios e sociedades irregulares
            value.substr(0, 2) != '98' && // não residentes
            value.substr(0, 2) != '99' // sociedades civis

        ) {
            error = 1;
        }
        var check1 = value.substr(0, 1) * 9;
        var check2 = value.substr(1, 1) * 8;
        var check3 = value.substr(2, 1) * 7;
        var check4 = value.substr(3, 1) * 6;
        var check5 = value.substr(4, 1) * 5;
        var check6 = value.substr(5, 1) * 4;
        var check7 = value.substr(6, 1) * 3;
        var check8 = value.substr(7, 1) * 2;

        var total = check1 + check2 + check3 + check4 + check5 + check6 + check7 + check8;
        var divisao = total / 11;
        var modulo11 = total - parseInt(divisao) * 11;
        if (modulo11 == 1 || modulo11 == 0) { comparador = 0; } // excepção
        else { comparador = 11 - modulo11; }


        var ultimoDigito = value.substr(8, 1) * 1;
        if (ultimoDigito != comparador) {
            error = 1;
        }

        return value.length == 9 && error == 0;
        // ? message ?? t('validation.nif') : "";

    }


    createRegexFromFormat(format) {
        let regexString = '^'; // Start of string anchor
        for (let i = 0; i < format.length; i++) {
            const char = format[i];
            switch (char) {
                case '#':
                    regexString += '\\d'; // Matches any digit
                    break;
                case '*':
                    regexString += '[a-zA-Z0-9]'; // Matches any alphanumeric character
                    break;
                case '_': //space
                    regexString += '[ ]'; // Matches any alphanumeric character
                    break;
                case '[':
                    // Find the closing bracket
                    const closingBracketIndex = format.indexOf(']', i);
                    if (closingBracketIndex !== -1) {
                        const literal = format.substring(i + 1, closingBracketIndex);
                        regexString += literal.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&'); // Escape special regex characters
                        i = closingBracketIndex;
                    }
                    break;
                default:
                    regexString += char.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&'); // Escape special regex characters
            }
        }
        regexString += '$'; // End of string anchor
        return new RegExp(regexString);
    }

    parseRulesWithGroups(rules) {
        if (!rules) { return []; }

        // Regular expression to split rules while respecting parentheses
        const ruleRegex = /\s*\|\|\s*(?![^()]*\))/g;
        const rulesArray = rules.split(ruleRegex);

        return rulesArray.map(rule => {
            if (rule.startsWith('(') && rule.endsWith(')')) {
                // Remove parentheses and split into sub-rules
                return this.parseRules(rule.slice(1, -1));
            } else {
                return rule;
            }
        });
    }
}




export default Validator;